export const aciPrinter = {
    iconName: 'printer',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 24 24' },
        path: [
            {
                attr: {
                    d: 'M5 17H2.467C1.657 17 1 16.36 1 15.571V8.43C1 7.639 1.657 7 2.467 7h19.066C22.343 7 23 7.64 23 8.429v7.142c0 .79-.657 1.429-1.467 1.429H19M4 10h1',
                    stroke: 'currentColor',
                    'stroke-width': '1.196',
                    'stroke-linecap': 'round',
                    'stroke-linejoin': 'round',
                },
            },
            {
                attr: {
                    'clip-rule': 'evenodd',
                    d: 'M5 13h14v10H5V13zM19 7H5V2.5C5 1.672 5.696 1 6.556 1h10.888C18.304 1 19 1.672 19 2.5V7z',
                    stroke: 'currentColor',
                    'stroke-width': '1.196',
                    'stroke-linecap': 'round',
                    'stroke-linejoin': 'round',
                },
            },
            {
                attr: {
                    d: 'M8 16h8M8 19h5',
                    stroke: 'currentColor',
                    'stroke-width': '1.196',
                    'stroke-linecap': 'round',
                    'stroke-linejoin': 'round',
                },
            },
        ],
    },
};
